//import 'react-app-polyfill/ie11';
//import 'react-app-polyfill/stable';

import '@/styles/app.scss'
import { ComponentType, FC, StrictMode } from 'react'
import { Route, BrowserRouter as Router } from 'react-router-dom'

if (import.meta.env.DEV) {
    await import('@/styles/preload.scss')
}

//import * as serviceWorker from './platformui/Base/ServiceWorker/serviceWorker';

import { Layout } from '@/framework/layouts/layout'
import { CookieContextProvider } from '@platformui/core/context/cookie-context'
import '@platformui/core/infrastructure/features/icons/icon-loader'
import { PageInfoProvider } from '@platformui/core/infrastructure/features/page-info/page-info-context'
import { WindowAccessProvider } from '@platformui/core/infrastructure/features/window/window-context'

import '@inera/ids-design/themes/inera/inera.css'
import {
    BreadcrumbsDto,
    BuildInfo,
    CookieConsent,
    LocalMenu,
    MainNavigation,
    Message,
    PWTSiteState,
    PreloadedStateMappers,
    PwtReactRenderContext,
    SecondaryNavigation,
    SiteFooterJsonModel,
    SiteHeaderJsonModel,
    SurveyEntry,
} from '@platformui/core/infrastructure/features/optimizely/types'

import { IneraReactPageState, IneraSiteState } from '@/inera-state-types'

//import Logo from './components/logo';
//import BuildInfo from './platformui/BuildInfo';

//import './framework/styles/app.scss';

// We import() just to create the chunks, but must not actually try to load the chunks here, so we
// wrap the import() in a lazy and then just never use it.
//React.lazy(() => import(/* webpackChunkName: "preload" */'./preload.js'));
//React.lazy(() => import(/* webpackChunkName: "editor" */'./editor.js'));

//const Preview = React.lazy(() => import(/* webpackChunkName: "preview" */'./framework/layouts/preview'));

// Additional requires that are not implicity loaded into the dependency graph. May require custom loading in webpack.config.js.
//require.resolve('./inera-manifest.json');
//require.resolve('powerbi-client/dist/powerbi.min.js'); // Needs to be dynamically/lazy-loaded since it expects 'window' to exist when loaded
//require.context('./framework/favicons/', true, /\.png$/);

export type AppClientProps<TPageState extends PWTSiteState> = {
    page: ComponentType
    rootProps: PwtReactRenderContext<TPageState>
}

const mappers: PreloadedStateMappers<IneraSiteState, IneraReactPageState> = {
    mapBreadcrumbs: (state: IneraReactPageState): BreadcrumbsDto | undefined =>
        state.breadcrumbs,
    mapMainNavigation: (
        state: IneraReactPageState
    ): MainNavigation | undefined => state.mainNavigation,
    mapSecondaryNavigation: (
        state: IneraReactPageState
    ): SecondaryNavigation | undefined => state.secondaryNavigation,
    mapLocalMenu: (state: IneraReactPageState): LocalMenu | undefined =>
        state.localMenu,
    mapSiteFooter: (siteState: IneraSiteState): SiteFooterJsonModel =>
        siteState.siteFooter,
    mapSiteHeader: (siteState: IneraSiteState): SiteHeaderJsonModel =>
        siteState.siteHeader,
    mapBuildInfo: (siteState: IneraSiteState): BuildInfo => siteState.buildInfo,
    mapSurveyEntries: (state: IneraReactPageState): SurveyEntry[] | undefined =>
        state.surveyEntries,
    mapMessages: (state: IneraReactPageState): Message[] | undefined =>
        state.messages,
    mapCookieConsent: (siteState: IneraSiteState): CookieConsent | undefined =>
        siteState.cookieConsent,
}

export const AppClient: FC<AppClientProps<IneraSiteState>> = ({
    page: Page,
    rootProps: props,
}) => {
    return (
        <StrictMode>
            <WindowAccessProvider>
                <PageInfoProvider<IneraSiteState, IneraReactPageState>
                    renderContext={props}
                    mappers={mappers}
                >
                    <CookieContextProvider
                        cookieProEnabled={
                            props?.pageState?.commonPageInfo?.cookieProEnabled
                        }
                    >
                        <Router>
                            <Route
                                path="*"
                                render={() => (
                                    <Layout
                                        Page={Page}
                                    />
                                )}
                            />
                        </Router>
                    </CookieContextProvider>
                </PageInfoProvider>
            </WindowAccessProvider>
        </StrictMode>
    )
}
